import { Injectable } from "@angular/core";
import { filter, mergeMap } from "rxjs/operators";
import { AuthService, LogoutOptions, RedirectLoginOptions } from "@auth0/auth0-angular";
import { KioskService } from "app/kiosk/kiosk.service";
import { Auth0User } from "./models/auth0-user.model";
import { EnvConfigProvider } from "./env-config.provider";
import { DealerService } from "app/dealer/dealer.service";
@Injectable({
	providedIn: "root",
})
export class Auth0Service {
	private __idToken: any;

	constructor(
		private __envConfigProvider: EnvConfigProvider,
		private __dealerService: DealerService,
		private __kioskService: KioskService,
		public __authService: AuthService
	) {
		this.__idToken = "";
	}

	private __storeUserDetails(isKiosk: boolean) {
		const auth0UserDetails = this.__idToken[
			this.__envConfigProvider.auth0Config.appMetaData
		];
		const auth0User = <Auth0User>{
			id: auth0UserDetails.id,
			name: auth0UserDetails.name,
			dealerName: auth0UserDetails.dealerName,
			target: "internet",
			email: auth0UserDetails.email,
			isEmailVerified: auth0UserDetails.email_verified,
		};
		if (isKiosk) {
			this.__kioskService.storeKiosk(auth0User);
		} else {
			this.__dealerService.storeDealer(auth0User);
		}
	}

	login(isKiosk: boolean) {
		this.__authService.isAuthenticated$.subscribe((isAuthenticated) => {
			if (isAuthenticated) {
				this.handleAuthCallback(isKiosk);
			} else {
				const options: RedirectLoginOptions<any> = {
					authorizationParams: {
						redirect_uri: `${window.location.origin}/${isKiosk ? "kiosk" : "dealer"}/auth0-callback`,
					}
				};
				this.__authService.loginWithRedirect(options);
			}
		});
	}

	handleAuthCallback(isKiosk: boolean) {
		this.__authService.idTokenClaims$.subscribe((claims) => {
			if (claims) {
				this.__idToken = claims;

				this.__storeUserDetails(isKiosk);
				window.location.replace(`/${isKiosk ? "kiosk" : "dealer"}/home`);
			} else {
				this.login(isKiosk);
			}
		});

		this.__authService.error$
			.pipe(
				filter((e) => e.name === "login_required"),
				mergeMap(() => this.__authService.loginWithRedirect())
			)
			.subscribe();
	}

	get idToken(): string {
		return this.__idToken;
	}

	public logoutDealer(): void {
		this.__idToken = "";
		this.__dealerService.deleteDealer();

		const options: LogoutOptions = {
			logoutParams: {
				returnTo: `${window.location.origin}/dealer/home`,
			}
		}
		this.__authService.logout(options);
	}

	public logoutKiosk(): void {
		this.__idToken = "";
		this.__kioskService.deleteKiosk();
		const options: LogoutOptions = {
			logoutParams: {
				returnTo: `${window.location.origin}/kiosk/home`,
			}
		}


		this.__authService.logout(options);
	}
}
